'use client';

import { useEffect, useState } from 'react';

import type { ConsentResult } from './get-client-consent-by-group-name';
import { getClientConsentByGroupName } from './get-client-consent-by-group-name';
import type { GroupName } from './one-trust-categorised-cookies';

export const useClientGetConsentByGroupName = (groupName: GroupName) => {
  const [consentStatus, setConsentStatus] = useState<ConsentResult>({
    result: 'unknown',
    reason: 'Waiting for OT to be available',
  });

  useEffect(() => {
    const findConsent = async () => {
      const result = await getClientConsentByGroupName(groupName);
      return setConsentStatus(result);
    };

    void findConsent();
  }, [groupName]);

  return consentStatus;
};
